function TopicController(){
	this.className			= "TopicController";
	this.glob				= "/**";
	this.priority			= 999;
	this.globUseHash		= true;
};
TopicController.inheritsFrom( StandardController );
TopicController.prototype.swap = function() {
	this.$html			= $('html, body');
	this.$page			= $('.js-page');
	this.$topics		= this.$page.find(".js-topics");
	this.$topic			= this.$page.find(".js-topic-section");
	this.$topicLink		= this.$page.find(".js-topic-link");
	this.$caseStudy		= this.$page.find(".js-case-study-footer");

	if(this.$caseStudy.size()){
		this.caseStudyTheme = false;
		const caseStudyThemeMatches = this.$caseStudy.attr('class').match(/(^|)theme-\S+/g)
		if(caseStudyThemeMatches.length){
			this.caseStudyTheme = caseStudyThemeMatches[0];
		}
	}

	this.topics = null;
	this.setupTopics();

	this.$topicLink.on('click touchstart', (e) => {
		if(e.cancelable) e.preventDefault();
		//this.closeTopics();
		const topicName = $(e.currentTarget).attr('data-topic');
		const nextTopic = this.getTopicByName(topicName);
		nextTopic.open();
	}).on('touchend', (e) => { e.preventDefault(); });

	this.resizeDelegate = jstage.addListener("resize", Igloo.delegate(this,this.onResize));

	return true;
}
TopicController.prototype.on = function() {
	return true;
};
TopicController.prototype.setupTopics = function($topic, show) {
	const topics = [];
	this.$topic.each(Igloo.$delegate(this, function($this, index) {
		const $elem = $this;

		const topic = {
			index: 				index,
			name: 				$elem.attr('data-name'),
			$elem: 				$elem,
			visible: 			false,
			$header: 			$elem.find(".js-topic-header"),
			$open: 				$elem.find(".js-topic-open"),
			$close: 			$elem.find(".js-topic-close"),
			$intro: 			$elem.find(".js-topic-intro"),
			$revealer: 			$elem.find(".js-topic-revealer"),
			$revealerInner: 	$elem.find(".js-topic-revealer-inner"),
			// $parent:			$elem.parents('.js-topics'),
			toggle:				Igloo.delegate(this,this.toggleTopic,index),
			open:				Igloo.delegate(this,this.toggleTopic,index, true),
			close:				Igloo.delegate(this,this.toggleTopic,index, false),
		};

		topic.$open.on('click touchstart', (e) => {
			if(e.cancelable) e.preventDefault();
			topic.open();
		}).on('touchend', (e) => { e.preventDefault(); });

		topic.$close.on('click touchstart', (e) => {
			if(e.cancelable) e.preventDefault();
			topic.close();
		}).on('touchend', (e) => { e.preventDefault(); });

		$elem.append(topic.$intro); // Append intro to bottom of topic, prefer in html but includes make this difficult.

		topics.push(topic);
	}));

	// console.log(topics);
	this.topics = topics;
}
TopicController.prototype.getTopic = function(index) {
	return (typeof this.topics === "object" && index in this.topics ? this.topics[index] : false);
}
TopicController.prototype.getTopicByName = function(name) {
	return this.topics.find(t => t.name === name);
}
TopicController.prototype.getVisibleTopic = function() {
	return this.topics.find(t => t.visible === true);
}
/*
TopicController.prototype.closeTopics = function() {
	for(const index in this.topics){
		const topic = this.topics[index];
		if(topic.visible){
			return topic.close();
		}
	}
}
*/
TopicController.prototype.toggleTopic = function(index, visible) {
	const topic = this.getTopic(index);
	if(!topic) return;

	// If opening a new topic and one is visible, close it and then open the next one.
	const visibleTopic = this.getVisibleTopic();
 	if(visible && visibleTopic) {
 		if(!this.isElementInViewport(topic.$elem)) this.scrollTopicIntoView(topic);
		return visibleTopic.close().then(() => this.toggleTopic(index, visible));
	}

 	// Save topic visibility
	if(visible !== undefined){
		topic.visible = visible;
	}

	// Scroll topic into view if not in viewport.
	if(visible && !this.isElementInViewport(topic.$elem)){
		return this.scrollTopicIntoView(topic).then(() => {
			return this.animateRevealerHeight(topic);
		});
	}

	return this.animateRevealerHeight(topic);
}
TopicController.prototype.animateRevealerHeight = function(topic) {
	const revealerHeight 	= topic.$revealerInner[0].scrollHeight;
	const revealerOffset 	= topic.$revealer.offset().top; //+ parseInt(this.$topics.css('margin-top'));
	const topicsOffset 		= this.$topics.offset().top;
	const newRevealerHeight = topic.visible ? revealerHeight : 0;
	const isOpening			= !!newRevealerHeight;

	if(!this.topicsOriginalHeight){
		this.topicsOriginalHeight = this.$topics.outerHeight();
		//console.log(this.topicsOriginalHeight);
	}

	const headerTheme = topic.$header.attr('data-theme');
	const revealerTheme = topic.$revealer.attr('data-theme');

	// Hide intro & animate text colour.
	if(topic.visible){
		topic.$intro.css({opacity: 0});
		this.$caseStudy.removeClass(this.caseStudyTheme).addClass(revealerTheme);
		topic.$header.addClass(headerTheme);
	}

	return topic.$revealer.stop().delay(100).animate({height: `${newRevealerHeight}px`}, {
		duration: 1000, //600,
		easing: (isOpening ? 'easeInCubic' : 'easeOutCubic'),
		step: (now, fx) => {

			// Animate topics height
			const newDynamicHeight = (now + (revealerOffset - topicsOffset));
			if(newDynamicHeight >= this.topicsOriginalHeight){
				this.$topics.css({height: `${newDynamicHeight}px`});
			}

			// Animate intro text
			if(!topic.visible && now === 0){
				topic.$intro.css({opacity: 1});
				topic.$header.removeClass(headerTheme);
				this.$caseStudy.removeClass(revealerTheme).addClass(this.caseStudyTheme);
				this.$topics.css('height', ''); // Reset topics height to auto at the end.
			}
		}
	}).promise();
}
TopicController.prototype.scrollTopicIntoView = function(topic) {
	const elemOffset = $(topic.$elem).offset().top - 200;
	return this.$html.animate({scrollTop: elemOffset}, {duration: 800}).promise();
}
TopicController.prototype.resizeTopics = function() {
	const topic = this.getVisibleTopic();
	if(!topic) return;

	const revealerHeight 	= topic.$revealerInner[0].scrollHeight;
	const topicsOffset 		= this.$topics.offset().top;
	const revealerOffset 	= topic.$revealer.offset().top;

	// Set revealer height
	topic.$revealer.css({height: `${revealerHeight}px`});

	// Set topics height
	const newTopicsHeight = (revealerOffset + revealerHeight - topicsOffset);
	this.$topics.css({height: `${newTopicsHeight}px`});
}
TopicController.prototype.isElementInViewport = function(elem) {
	const $elem = elem[0];
	var rect = $elem.getBoundingClientRect();
	return (
		rect.top >= 0 &&
		rect.left >= 0 &&
		rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) && /* or $(window).height() */
		rect.right <= (window.innerWidth || document.documentElement.clientWidth) /* or $(window).width() */
	);
}
TopicController.prototype.onResize = function() {
	this.resizeTopics();
};
TopicController.prototype.off = function(){
	if(this.onResize) jstage.removeListener("resize",this.resizeDelegate);
}
